import Styles from './UploadsDrawer.module.scss'
import { geoShapes } from 'components/Design/ElementsTab/components/shapes'
import { GeoShapesGrid } from 'components/Design/ElementsTab/components/GeoShapesGrid'

export const ShapesPanel = () => {
  return (
    <div>
      <div className={Styles.sectionContainer}>
        <GeoShapesGrid shapesToDisplay={geoShapes} />
      </div>
    </div>
  )
}
